import classnames from 'classnames'
import NextLink from 'next/link'

import styles from './index.module.scss'

export type Crumb = {
  id: string
  label: string
  href: string
}

export type BreadcrumbsProps = {
  crumbs: Crumb[]
  variant?: 'default'
  className?: string
}

export const Breadcrumbs = ({ crumbs, className, variant = 'default' }: BreadcrumbsProps) => {
  return (
    <ul
      aria-label="breadcrumb"
      className={classnames(styles['breadcrumb'], styles[variant], className)}
    >
      {crumbs.map((crumb, index) => (
        <li className={styles['crumb']} key={crumb.id}>
          {index !== crumbs.length - 1 ? (
            <>
              <NextLink href={crumb.href} className={styles['label']}>
                {crumb.label}
              </NextLink>
              <span className={styles['slash']}>/</span>
            </>
          ) : (
            <span aria-disabled className={classnames(styles['label'], styles['disabled'])}>
              {crumbs[crumbs.length - 1].label}
            </span>
          )}
        </li>
      ))}
    </ul>
  )
}

export default Breadcrumbs
